import manageRedCross from './ManageRedCross'
export default manageRedCross;